import React from 'react'
import { TerminalStatus, TerminalStatusContext } from '../../../types/mf-execution.types'
import { AllStatusWrapper } from '../../../components/execution/terminal/AllStatusWrapper'
import { postCTA } from '../../../utils/appBridge'
import { getOrdersTabCTA } from '../../../utils/mutualFundDetail'

const WithdrawFailedPage: React.FC = () => {
  return (
    <div className='w-full h-screen relative overflow-hidden'>
      <AllStatusWrapper
        status={TerminalStatus.FAILURE}
        statusContext={TerminalStatusContext.WITHDRAW}
        failureConfig={{
          title: 'Withdrawal failed',
          caption: "We couldn't place your request at the moment. Please try again.",
          ctas: [
            {
              ctaType: 'primary',
              label: 'Go to dashboard',
              onClick: () => {
                // Handle navigation to dashboard
                console.log('Navigate to dashboard')
                postCTA(JSON.stringify(getOrdersTabCTA()))
              }
            }
          ]
        }}
      />
    </div>
  )
}

export default WithdrawFailedPage
